import { CarTypes, RimTypes } from '@/utils/constants';

function scrollValidationErrorsIntoView(validationObserver) {
    //get errors from validationObserver
    const errors = Object.entries(validationObserver.refs)
        .map(([key, value]) => ({
            key,
            value
        }))
        .filter(error => {
            if (!error || !error.value || !error.value.failedRules) return false;
            return Object.keys(error.value.failedRules).length > 0;
        });

    //pick first error and scroll to it
    if (errors && errors.length > 0) {
        window.setTimeout(() => {
            validationObserver.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 100);
    }
}

export function doValidation(validationObserver, validCallback, invalidCallback) {
    if (validationObserver) {
        validationObserver.validate().then((isValid) => {
            if (isValid) {
                if (validCallback) {
                    validCallback();
                }
            } else {
                scrollValidationErrorsIntoView(validationObserver);
                if (invalidCallback) {
                    invalidCallback();
                }
            }
        });
    } else {
        throw 'validationObserver is missing';
    }
}

export function formatPercentage(value) {
    if (typeof value === 'undefined' || value === '')
        return '';

    var num = Number(value);

    if (isNaN(num))
        return '';

    return num.toLocaleString('de-CH', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export function getServicePrice(service, state) {
    switch (state.carType) {
        case CarTypes.PKW:
            switch (state.rimType) {
                case RimTypes.Steel:
                    return service.PricePKWSteel;
                case RimTypes.Aluminium:
                    return ((state.selectedTyre.RimSize < 18.0) ? service.PricePKWAlu17 : service.PricePKWAlu18);
            }
            break;
        case CarTypes.SUV:
            return service.PriceSUV;
        case CarTypes.LLKW:
            return service.PriceLLKW;
    }
}